import React from 'react'
import { Container } from 'reactstrap'

const STEPS = [
  'Engage with Cloudnexa',
  'AWS environment review',
  'Present review findings',
  'Schedule remediations',
]

const ReviewProcess = () => {
  return (
    <section className="ReviewProcess">
      <Container>
        <h2 className="ReviewProcess__title">
          Our Well-Architected{' '}
          <span className="text-dark-blue">Review Process</span>
        </h2>
        <div className="ReviewProcess__lead">
          We want our customers to have the best possible experience with cloud
          solutions. Follow our review process to make an informed decision
        </div>

        <div className="d-md-flex">
          {STEPS.map((step, idx) => (
            <div key={idx} className="ReviewProcess__col">
              <div className="ReviewProcess__step">
                <div className="ReviewProcess__stepCount">{idx + 1}</div>
                <div className="ReviewProcess__stepTitle">{step}</div>
              </div>
            </div>
          ))}
        </div>

        <a href="/contact" className="btn btn-primary mt-5">
          Schedule Your Review
        </a>

        <a
          href="https://register.gotowebinar.com/#recording/6407943177959301384"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-primary mt-3 mt-md-5 ml-md-3"
        >
          Watch Webinar Overview
        </a>
      </Container>
    </section>
  )
}

export default ReviewProcess
